module.exports = __webpack_public_path__ + "static/media/close.23657d65.svg";